import classNames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { IconDownload } from '@picsart/icons';

import { Button } from '../../../core/Button/Button';

import useStyles from './styles';
import { IDownloadWidget } from './types';

function DownloadWidget({ imageName = '', handleDownload, ...rest }: IDownloadWidget) {
  const classes = useStyles();

  return (
    <>
      <FileViewer imageName={imageName} {...rest} />

      <Button
        onClick={handleDownload}
        download={imageName}
        className={classNames(classes.footerButtons, classes.downloadBtn)}
      >
        <IconDownload />
        Download
      </Button>
    </>
  );
}

const FileViewer = ({
  type,
  imageName,
  imgSrc,
  imgAlt,
  imgContainerClassName,
  imgHeight = 44,
  imgWidth = 38,
}: Omit<IDownloadWidget, 'handleDownload'>) => {
  const classes = useStyles();

  const width = type === 'file' ? imgWidth : '100%';
  const height = type === 'file' ? imgHeight : '100%';

  return (
    <div className={classNames(classes.imgContainer, imgContainerClassName)}>
      <LazyLoadImage src={imgSrc} alt={imgAlt} width={width} height={height} />
      {type === 'file' ? imageName : null}
    </div>
  );
};

export default DownloadWidget;
